import { render, staticRenderFns } from "./WikiPageDraftList.vue?vue&type=template&id=1cc0fbf4"
import script from "./WikiPageDraftList.vue?vue&type=script&lang=ts"
export * from "./WikiPageDraftList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports